"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptwViolationSummarySchema = exports.ptwViolationDecisionSchema = exports.izindeAranirSchema = exports.ptwJsaRowSchema = exports.ptwJsaSetSchema = exports.ptwJsaSatirSchema = exports.ptwParticipantsSetSchema = exports.ptwOnayUygunluguSchema = exports.ptwUygunlukSonucuSchema = exports.ptwUygunlukKalemiSchema = exports.ptwUygunlukKuralSchema = exports.PTW_UYGUNLUK_KURALLARI = exports.ptwUygunlukKontrolTipiSchema = exports.PTW_UYGUNLUK_KONTROL_TIPLERI = exports.ptwApprovalDecisionContractIsInSync = exports.ptwPendingApprovalContractIsInSync = exports.ptwPermitSummaryContractIsInSync = exports.ptwKatilimciKararBekleyenContractIsInSync = exports.approvalChainContractIsInSync = exports.ptwApprovalDecisionResultSchema = exports.ptwApprovalDecisionSchema = exports.PTW_ONAY_GEREKCE_ZORUNLU_MESAJI = exports.PTW_KATILIMCI_CAKISMA_METNI = exports.ptwOnaySonucSchema = exports.PTW_ONAY_SONUCLARI = exports.ptwPendingApprovalSchema = exports.ptwPermitSummarySchema = exports.ptwSorumluSetSchema = exports.ptwPermitCreateSchema = exports.approvalChainDetailSchema = exports.approvalChainStepDetailSchema = exports.approvalChainStarterSchema = exports.approvalChainUpdateSchema = exports.approvalChainCreateSchema = exports.approvalChainStepInputSchema = exports.PTW_ISLEM_ETIKETI = exports.PTW_KAYIT_ISLEMLERI = exports.PTW_GECIS_MATRISI = exports.ptwIhlalKararSchema = exports.PTW_IHLAL_KARARLARI = exports.ptwGeriCekilmeKaynakSchema = exports.PTW_GERI_CEKILME_KAYNAKLARI = exports.ptwOnayKapiSchema = exports.PTW_ONAY_KAPILARI = exports.PTW_SUPER_DURUM_ETIKETI = exports.ptwSuperDurumSchema = exports.PTW_SUPER_DURUMLARI = exports.PTW_DURUM_ETIKETI = exports.ptwDurumSchema = exports.PTW_DURUMLARI = void 0;
exports.ptwAuthorityWriteSchema = exports.ptwWorkplaceTypeWriteSchema = exports.ptwTypeGorevWriteSchema = exports.ptwTypeFormSchema = exports.ptwPermitFilterOptionsContractIsInSync = exports.ptwPermitOptionsContractIsInSync = exports.ptwPermitDetailContractIsInSync = exports.ptwPermitListContractIsInSync = exports.ptwPermitOptionsSchema = exports.ptwPermitDetailSchema = exports.ptwUzatmaTalebiSchema = exports.ptwEkipmanSatiriSchema = exports.ptwKatilimciKararBekleyenSchema = exports.ptwKatilimciKararSchema = exports.PTW_KATILIMCI_RET_GEREKCE_METNI = exports.ptwAktifKatilimciEklemeSchema = exports.ptwKatilimciSatiriSchema = exports.ptwGeriCekilmeSatiriSchema = exports.ptwTaramaSatiriSchema = exports.ptwDevirSatiriSchema = exports.ptwIzolasyonSatiriSchema = exports.ptwKilitSatiriSchema = exports.ptwOnayBasamaklariSchema = exports.ptwOnayBasamagiSchema = exports.ptwOnaySatiriSchema = exports.ptwGecisSatiriSchema = exports.ptwPermitYetkileriSchema = exports.PTW_ITA_KILIT_METNI = exports.PTW_TASLAK_ICERIK_KILITLERI = exports.ptwPermitFilterOptionsSchema = exports.PTW_SAYFA_BOYUTU = exports.BOS_PTW_IZIN_SUZGECI = exports.ptwPermitListResponseSchema = exports.ptwSuperDurumSayaclariSchema = exports.PTW_QR_OZET_ALANLARI = exports.ptwQrDurumSchema = exports.ptwEquipmentScanSonucuSchema = exports.ptwEquipmentScanSchema = exports.ptwIsolationLockRemoveSchema = exports.ptwIsolationCreateSchema = exports.ptwHandoverStartSchema = exports.ptwSuspendSchema = exports.ptwCihazAtSchema = exports.ptwCancelSchema = exports.ptwExtensionRequestSchema = exports.ptwWithdrawSchema = exports.ptwViolationSummaryContractIsInSync = exports.ptwUygunlukSonucuContractIsInSync = exports.ptwQrDurumContractIsInSync = exports.ptwEquipmentScanContractIsInSync = void 0;
exports.ptwBriefingListSchema = exports.ptwBriefingCreateSchema = exports.PTW_BRIFING_KONU_ALANLARI = exports.PTW_BRIFING_NOT_MAX_UZUNLUK = exports.PTW_BRIFING_YAZILABILIR_DURUMLAR = exports.PTW_KUNYE_ONAY_GEREKLI_METNI = exports.ptwKunyeOnayGerekliSchema = exports.ptwDusecekIcerikSchema = exports.ELLE_GIRILEN_ALAN_TIPLERI = exports.PTW_ELLE_ICERIK_ETIKETI = exports.PTW_ELLE_ICERIK_SINIFLARI = exports.ptwKunyeSetSchema = exports.ptwConfigOverviewContractIsInSync = exports.ptwTypeFormContractIsInSync = exports.ptwConfigOverviewSchema = exports.ptwQrKapsamWriteSchema = void 0;
exports.ptwSuperDurumOf = ptwSuperDurumOf;
exports.ptwSuperDurumTokenlari = ptwSuperDurumTokenlari;
exports.ptwIslemEtiketi = ptwIslemEtiketi;
exports.ptwGecisTanimi = ptwGecisTanimi;
exports.ptwGecisIzinliMi = ptwGecisIzinliMi;
exports.ptwOnayGerekcesiZorunluMu = ptwOnayGerekcesiZorunluMu;
exports.basamakAdAnahtari = basamakAdAnahtari;
exports.cakisanBasamakAdlari = cakisanBasamakAdlari;
exports.readIzindeAranir = readIzindeAranir;
exports.readOnKosul = readOnKosul;
exports.ptwIzinSuzgecSorgusu = ptwIzinSuzgecSorgusu;
exports.etkinPtwSuzgeciSayisi = etkinPtwSuzgeciSayisi;
exports.ptwTaslakIcerikKilidi = ptwTaslakIcerikKilidi;
exports.ptwBrifingYazilabilirMi = ptwBrifingYazilabilirMi;
const zod_1 = require("zod");
const ptw_kontrol_matrisi_1 = require("./ptw-kontrol-matrisi");
const shared_types_1 = require("@isg/shared-types");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * PTW durum makinesi sabitleri (F3·S1 — Kapsam §16.7, ERD §5.1 + §12/2;
 * 11.08.2026 tasarım tutanağı T1 + F3·S0 rol-geçiş matrisi).
 *
 * Üç katmanın paylaştığı tek kaynak: token listesi, süper-durum eşlemesi ve
 * rol-geçiş matrisi burada durur — @isg/db durum makinesi geçiş kurallarını
 * BURADAN okur, web tipleri buradan türer. İkinci bir eşleme/matris yazılmaz.
 */
/** 11 token — T1 (11.08.2026) KAPALI LİSTE; sıra akış sırasıdır, geçişi kod zorlar. */
exports.PTW_DURUMLARI = [
    'draft',
    'area_review',
    'manager_approval',
    'active',
    'suspended',
    'expired',
    'work_completed',
    'closure_approval',
    'closed',
    'cancelled',
    'rejected',
];
exports.ptwDurumSchema = zod_1.z.enum(exports.PTW_DURUMLARI);
/**
 * DURUM ETİKETLERİ — TEK KOPYA, ÜÇ KATMAN (tur 10 / K7.1).
 *
 * ⚠️ **NEDEN `@isg/validation`, NEDEN `apps/web/src/i18n/tr.ts` DEĞİL:** bu
 * harita 22.08.2026'dan beri **yalnız web'de** duruyordu ve sunucu, ret
 * mesajlarında token'ın kendisini basıyordu (*"'isim_bitti' işlemi 'active'
 * durumundaki izinde tanımlı değil"*). Kullanıcı `active`i okumaz; §2.40'ın
 * D2 kolu **ret mesajının da kullanıcı dilinde olmasını** ister. Etiketi
 * sunucuda ikinci kez yazmak §2.31a'nın (*"menü rol listesi yazmaz, IMPORT
 * eder"*) tam olarak yasakladığı şeydi — bu yüzden harita üç katmanın
 * paylaştığı yere taşındı ve **web onu buradan yeniden dışa verir.**
 *
 * ⚠️ **§10 İHLAL EDİLMEDİ:** enum'a Türkçe metin GİRMEZ — token'lar İngilizce
 * kalır; bu ayrı bir eşlemedir.
 */
exports.PTW_DURUM_ETIKETI = {
    draft: 'Taslak',
    area_review: 'Bölge kontrolü',
    // ✏️ BULGU 95 / K-95b (16.09.2026): bu token ZİNCİR TAMAMLANDIKTAN SONRAKİ
    // hâldir (`onay_ilerleme`in hedefi) — eski "Üst amir onayı" etiketi onu onay
    // BEKLİYOR gibi gösteriyordu (yalan söyleyen etiket, §2.40).
    manager_approval: 'Onaylandı — işbaşı bekleniyor',
    active: 'Aktif',
    suspended: 'Askıda',
    expired: 'Süresi doldu',
    work_completed: 'İş bitti bildirildi',
    closure_approval: 'Kapanış onayında',
    closed: 'Kapandı',
    cancelled: 'İptal edildi',
    rejected: 'Reddedildi',
};
/**
 * Süper-durum — 5 şapka (T1). KOLON DEĞİLDİR: liste ekranları/sayaçlar bu
 * eşlemeden SAYAR, geçiş kuralları token düzeyinde kalır. Token'lar ASCII
 * Türkçe saha kavramı (jsonb anahtar ekseni); ekran etiketi i18n'den.
 */
exports.PTW_SUPER_DURUMLARI = [
    'hazirlik',
    'onayda',
    // ✏️ BULGU 95 / K-95b (16.09.2026 — Kapsam T1 revizyonu, 5 → 6 şapka): onay
    // bekleyen izinle ONAYLANMIŞ izin aynı kutuda duramaz — onaycı boşuna bakar,
    // güncel sorumlu kendi işini bulamaz.
    'isbasi_bekliyor',
    'sahada',
    'kapanista',
    'bitti',
];
exports.ptwSuperDurumSchema = zod_1.z.enum(exports.PTW_SUPER_DURUMLARI);
/** Süper-durum etiketleri — `PTW_DURUM_ETIKETI` ile aynı gerekçe (K7.1):
 *  çıktı anteti ve süzgeç özeti de sunucuda basılır. */
exports.PTW_SUPER_DURUM_ETIKETI = {
    hazirlik: 'Hazırlık',
    onayda: 'Onayda',
    isbasi_bekliyor: 'İşbaşı bekleyen',
    sahada: 'Sahada',
    kapanista: 'Kapanışta',
    bitti: 'Bitti',
};
const SUPER_DURUM_ESLEME = {
    draft: 'hazirlik',
    area_review: 'onayda',
    manager_approval: 'isbasi_bekliyor',
    active: 'sahada',
    suspended: 'sahada',
    expired: 'sahada',
    work_completed: 'kapanista',
    closure_approval: 'kapanista',
    closed: 'bitti',
    cancelled: 'bitti',
    rejected: 'bitti',
};
/** Token → süper-durum (T1, 5 şapka). Eşleme Record olduğundan yeni token
 *  eklendiğinde satırı unutmak DERLEME hatasıdır (kapalı liste güvencesi). */
function ptwSuperDurumOf(durum) {
    return SUPER_DURUM_ESLEME[durum];
}
/**
 * Süper-durum → o şapkaya düşen TOKEN'lar (K5, tur 10). `ptwSuperDurumOf`ın
 * tersidir ve **aynı eşlemeden** türer: liste süzgeci sekmeyi SORGUDA
 * uygulayabilsin diye (sayfalama, satırları çekip JS'te süzmeyi imkânsız
 * kılar). İkinci bir eşleme yazılsaydı, yeni bir token eklendiğinde biri
 * güncellenir diğeri sessizce eskirdi.
 */
function ptwSuperDurumTokenlari(superDurum) {
    return exports.PTW_DURUMLARI.filter((token) => SUPER_DURUM_ESLEME[token] === superDurum);
}
/** Onay kapısı (S0-K4 simetrisi): açılış · uzatma · kapanış — üçü aynı zincirden. */
exports.PTW_ONAY_KAPILARI = ['acilis', 'uzatma', 'kapanis'];
exports.ptwOnayKapiSchema = zod_1.z.enum(exports.PTW_ONAY_KAPILARI);
/** Geri çekilme kaydının kaynağı (K2/K7). */
exports.PTW_GERI_CEKILME_KAYNAKLARI = ['manuel', 'ihlal_karari'];
exports.ptwGeriCekilmeKaynakSchema = zod_1.z.enum(exports.PTW_GERI_CEKILME_KAYNAKLARI);
/** K7 ihlal kararı: sürdür (gerekçeli) / geri çek (K2 yolu). */
exports.PTW_IHLAL_KARARLARI = ['surdur', 'geri_cek'];
exports.ptwIhlalKararSchema = zod_1.z.enum(exports.PTW_IHLAL_KARARLARI);
/**
 * ROL-GEÇİŞ MATRİSİ — ERD §12/2'nin 15 satırının durum-geçişi üreten kolu,
 * BİREBİR (F3·S0 kapanışı, 11.08.2026). Satır 6 (devir), 8 (ihlal kararı),
 * 11 (izolasyon/kilit) ve 12 (zorla kaldırma) durum geçişi ÜRETMEZ — kayıt
 * işlemleridir (PTW_KAYIT_ISLEMLERI); satır 8'in geri_cek kolu satır 7'nin
 * geçişine düşer. Matris dışı her (eski, yeni, işlem) FAIL-CLOSED reddedilir
 * (409) — buraya satır eklemek ürün kararıdır.
 */
exports.PTW_GECIS_MATRISI = [
    // 1 — Talep gönder (oluştur/düzenle geçiş değildir; draft içi iştir).
    {
        satir: 1,
        islem: 'talep_gonder',
        eski: ['draft'],
        yeni: 'area_review',
        tetikleyen: 'talep_eden',
    },
    // 2 — İptal: YALNIZ aktife hiç geçmemiş talep (K13 + S0-K5). Aktiften
    // cancelled YOKTUR — kapsam değişikliği dahil çıkış geri çekilme yoludur.
    {
        satir: 2,
        islem: 'iptal',
        eski: ['draft', 'area_review', 'manager_approval'],
        yeni: 'cancelled',
        tetikleyen: 'talep_eden',
    },
    // 3 — Onay basamağının üç sonucu (K3/K4 · T1). Basamaklar PARALEL koşar;
    // token ilerlemesi/tamamlanma mantığı S2 onay motorunun işi.
    {
        satir: 3,
        islem: 'onay_ilerleme',
        eski: ['area_review'],
        yeni: 'manager_approval',
        tetikleyen: 'zincir_havuzu',
    },
    {
        satir: 3,
        islem: 'revizyon_iste',
        eski: ['area_review', 'manager_approval'],
        yeni: 'draft',
        tetikleyen: 'zincir_havuzu',
    },
    {
        satir: 3,
        islem: 'red',
        eski: ['area_review', 'manager_approval'],
        yeni: 'rejected',
        tetikleyen: 'zincir_havuzu',
    },
    // 4 — Aktife geçiş: işbaşı doğrulaması (S3) + güncel sorumlu.
    {
        satir: 4,
        islem: 'aktife_gecis',
        eski: ['manager_approval'],
        yeni: 'active',
        tetikleyen: 'guncel_sorumlu',
        isbasiDogrulamasi: true,
    },
    // 5 — Askı: ekibin KENDİ duraksaması (yetkilinin askı aracı yoktur — K2);
    // dönüşte işbaşı doğrulaması YENİDEN koşar (S3).
    {
        satir: 5,
        islem: 'askiya_al',
        eski: ['active'],
        yeni: 'suspended',
        tetikleyen: 'guncel_sorumlu',
    },
    {
        satir: 5,
        islem: 'askidan_don',
        eski: ['suspended'],
        yeni: 'active',
        tetikleyen: 'guncel_sorumlu',
        // ✏️ K-96: askıdan dönüş işbaşı doğrulamasının TEKRARIDIR (§2.6/3) —
        // iş durmuş, ekip dağılmış, ortam değişmiş olabilir.
        isbasiDogrulamasi: true,
    },
    // 7 — Geri çekilme: zorlanmış kapanış girişi (K2 — ptw_withdrawal kaydıyla
    // ATOMİK); yetki şapka listesi + TABAN izin veren (S0-K1).
    {
        satir: 7,
        islem: 'geri_cekilme',
        eski: ['active'],
        yeni: 'work_completed',
        tetikleyen: 'sapka_listesi',
    },
    // 9 — Süre dolumu: SİSTEM geçişi (BullMQ zamanlanmış iş); askıdaki iznin
    // süresi de dolar. expired ARA haldir — iş fiilen durmaz, izin geçerli sayılmaz.
    //
    // ✏️ BULGU 95 / K-95b (16.09.2026 — ERD §12/2 satır 9 revizyonu):
    // `manager_approval` KAYNAK DURUM OLARAK EKLENDİ; yeni satır AÇILMADI (K3.1
    // emsali). Onay izni verir, aktife geçişi güncel sorumlu yapar (satır 4 AYNEN
    // — K-95a revizyonu); onayı tamamlanmış ama hiç işbaşı yapılmamış izin bitiş
    // saati geçince SESSİZCE ASILI KALIRDI. ✏️ Madde 257 (K-257): böyle bir iznin
    // uzatması işbaşı beklemeye döner — satır 10'un ikinci kolu.
    {
        satir: 9,
        islem: 'sure_dolumu',
        eski: ['active', 'suspended', 'manager_approval'],
        yeni: 'expired',
        tetikleyen: 'sistem',
    },
    // 10 — Uzatma: güncel sorumlu başlatır, AYNI zincir onaylar (paralelse
    // hepsi yeniden bakar) — onay çözümlemesi S2.
    {
        satir: 10,
        islem: 'uzatma_onayi',
        eski: ['expired'],
        yeni: 'active',
        tetikleyen: 'zincir_havuzu',
    },
    // ✏️ K-257 (16.09.2026 — madde 257): HİÇ AKTİFE GEÇMEMİŞ izin uzatılınca
    // İŞBAŞI BEKLEMEYE döner, doğrudan aktif olmaz. Uzatma iznin SÜRESİNİ
    // değiştirir, işbaşı teyidini değil: sahaya hiç çıkmamış iş uzatıldı diye
    // çıkmış sayılamaz. Yeni satır AÇILMADI (satır 10'un ikinci kolu — işlem
    // aynı karar, tetikleyen aynı zincir); hangi kolun koşacağı iznin geçiş
    // izinden türetilir (`@isg/db ptwHicAktifOlduMuTx`).
    {
        satir: 10,
        islem: 'uzatma_onayi_isbasi',
        eski: ['expired'],
        yeni: 'manager_approval',
        tetikleyen: 'zincir_havuzu',
    },
    // 13 — "İşim bitti": güncel sorumlu (son devralan — K1); expired'ın ikinci
    // çıkışı da kapanışa gitmektir (§16.7.2).
    //
    // ✏️ TUR 10 / K3.1 (05.09.2026 — Kapsam §16.7, ERD §12/2 satır 13 revizyonu):
    // `suspended` KAYNAK DURUM OLARAK EKLENDİ. Yeni satır AÇILMADI — işlem aynı,
    // tetikleyen aynı (güncel sorumlu); değişen yalnız hangi hâlden çıkılabildiği.
    // ⚠️ GEREKÇE SAHA GERÇEĞİ: fiziksel işi bitmiş ama UYGUNLUĞU BOZULDUĞU İÇİN
    // askıdan dönemeyen izin kilitliydi (askıdan dönüş işbaşı doğrulamasından
    // geçer — satır 5) ve tek çıkışı süre dolumunu beklemekti. Kilitli izin,
    // sahada izinsiz çalışmayı teşvik eder.
    // ⚠️ KAPANIŞ İKİ ADIMLI KALIR: işim bitti → saha kontrolü → kapanış onayı;
    // açık izolasyon varken kapanış yine REDDEDİLİR (approvePtwClosure).
    {
        satir: 13,
        islem: 'isim_bitti',
        eski: ['active', 'expired', 'suspended'],
        yeni: 'work_completed',
        tetikleyen: 'guncel_sorumlu',
    },
    // 14 — Saha kontrolü: şapka listesi (S0-K3 — liste boş olamaz).
    {
        satir: 14,
        islem: 'saha_kontrol',
        eski: ['work_completed'],
        yeni: 'closure_approval',
        tetikleyen: 'sapka_listesi',
    },
    // 15 — Kapanış onayı: TÜM zincir paralel (S0-K4); açık izolasyon varken
    // REDDEDİLİR (§2.6b — @isg/db approvePtwClosure). Ret saha kontrolü
    // adımına DÖNER (S0-K4 🔧).
    {
        satir: 15,
        islem: 'kapanis_onayi',
        eski: ['closure_approval'],
        yeni: 'closed',
        tetikleyen: 'zincir_havuzu',
    },
    {
        satir: 15,
        islem: 'kapanis_ret',
        eski: ['closure_approval'],
        yeni: 'work_completed',
        tetikleyen: 'zincir_havuzu',
    },
];
/**
 * Matrisin durum geçişi üretmeyen satırları — KAYIT işlemleri (tam 15 satır
 * güvencesinin öbür yarısı; envanter testi iki listenin satır birleşimini
 * 1-15'e kilitler).
 */
exports.PTW_KAYIT_ISLEMLERI = [
    {
        satir: 6,
        islem: 'devir_baslat_kabul',
        tetikleyen: 'guncel_sorumlu / devralan (uygunluk kapılı — S3)',
    },
    { satir: 8, islem: 'ihlal_karari', tetikleyen: 'izin_veren' }, // geri_cek kolu satır 7'nin geçişine düşer
    { satir: 11, islem: 'izolasyon_ve_kilit', tetikleyen: 'kaydi_acan / kilidi_takan' },
    { satir: 12, islem: 'zorla_kilit_kaldirma', tetikleyen: 'izin_veren onayı + kesen kaydı' },
];
/**
 * İŞLEM ETİKETLERİ — TEK KOPYA, ÜÇ KATMAN (tur 10 / K7.1; `PTW_DURUM_ETIKETI`
 * ile aynı gerekçe).
 *
 * ⚠️ **DÖRT KAYIT İŞLEMİ DE BURADADIR** (`PTW_KAYIT_ISLEMLERI` — geçiş
 * üretmeyen satırlar): eksik bırakılsalardı geçmiş kaydı çizen ekran onları
 * ham kodla gösterirdi. Envanter testi haritanın matrisin + kayıt
 * işlemlerinin **tamamını** kapsadığını ölçer.
 */
exports.PTW_ISLEM_ETIKETI = {
    talep_gonder: 'Talep gönderildi',
    iptal: 'Talep iptal edildi',
    onay_ilerleme: 'Onay tamamlandı',
    revizyon_iste: 'Revizyon istendi',
    red: 'Reddedildi',
    aktife_gecis: 'Aktife geçildi (işbaşı doğrulaması)',
    askiya_al: 'Askıya alındı',
    askidan_don: 'Askıdan dönüldü',
    geri_cekilme: 'Geri çekildi',
    sure_dolumu: 'Süresi doldu (sistem)',
    uzatma_onayi: 'Uzatma onaylandı',
    uzatma_onayi_isbasi: 'Uzatma onaylandı — işbaşı bekleniyor',
    isim_bitti: '"İşim bitti" bildirildi',
    saha_kontrol: 'Saha kontrolü yapıldı',
    kapanis_onayi: 'Kapanış onaylandı',
    kapanis_ret: 'Kapanış reddedildi (saha kontrolüne döndü)',
    devir_baslat_kabul: 'Vardiya devri',
    ihlal_karari: 'Uygunsuzluk kararı',
    izolasyon_ve_kilit: 'İzolasyon / kişisel kilit',
    zorla_kilit_kaldirma: 'Kilit zorla kaldırıldı',
};
/**
 * İşlemin kullanıcıya söylenecek adı. Harita dışı kod GERİ DÜŞÜŞTE kodun
 * kendisini verir — sessizce boş dönmez (boş bir cümle, kodu basmaktan da
 * kötüdür).
 */
function ptwIslemEtiketi(islem) {
    return exports.PTW_ISLEM_ETIKETI[islem] ?? islem;
}
/** İşlem koduna göre geçiş tanımı; matris dışı işlem → undefined (fail-closed
 *  ret çağıranda). */
function ptwGecisTanimi(islem) {
    return exports.PTW_GECIS_MATRISI.find((g) => g.islem === islem);
}
/** (eski, yeni) token çifti matriste tanımlı mı — envanter/negatif testlerin
 *  ve hızlı ön kontrolün yardımcısı. */
function ptwGecisIzinliMi(eski, yeni) {
    return exports.PTW_GECIS_MATRISI.some((g) => g.yeni === yeni && g.eski.includes(eski));
}
// ── F3·S2: onay zinciri motorunun API sözleşmeleri (Kapsam §16.7, ERD §5.3) ──
//
// Çıktı şemaları AssertExact ile @isg/shared-types tiplerine kilitli (index.ts
// deseni). AssertExact burada YEREL tanımlıdır: index.ts bu dosyayı
// `export *` ile yeniden dışa verir — ondan içe alma dairesel olurdu.
/** ZİNCİR TANIMI — girdi (yalnız holding_admin; yetki uçta, §20.5). */
exports.approvalChainStepInputSchema = zod_1.z.object({
    sira: zod_1.z.number().int().min(1).max(99),
    ad: zod_1.z.string().trim().min(1).max(120),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES),
    izinVeren: zod_1.z.boolean(),
});
/**
 * Zincir oluşturma: AYNI zincir tanımı ÇOK İŞYERİNE atanabilir (K4 üçüncü
 * adım) — her işyeri için bir `approval_chain` satırı doğar (anahtar
 * `(workplace_id, izin_turu)`; v1'de izin türü HER ZAMAN null).
 *
 * `steps` en az bir basamak ister; "zincirde TAM BİR izin veren" kuralı
 * (K3) @isg/db `assertApprovalChainValid`tedir — şema onu tekrarlamaz
 * (tek kaynak: kural DB katmanında, ret 422).
 */
exports.approvalChainCreateSchema = zod_1.z.object({
    workplaceIds: zod_1.z.array(zod_1.z.uuid()).min(1),
    ad: zod_1.z.string().trim().min(1).max(160),
    steps: zod_1.z.array(exports.approvalChainStepInputSchema).min(1),
});
/** Zincir düzenleme: ad + basamak listesinin TAMAMI (basamaklar değiştirilir). */
exports.approvalChainUpdateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1).max(160),
    steps: zod_1.z.array(exports.approvalChainStepInputSchema).min(1),
});
/**
 * BAŞLANGIÇ ŞABLONU (K4): tek basamak — alan sorumlusu = izin veren.
 * Sistem şablonu ÖNERİR, kurmaz: uç yalnız holding yöneticisinin açık
 * çağrısıyla çalışır (güvenlik işinde imza sahibine biz karar vermeyiz).
 */
exports.approvalChainStarterSchema = zod_1.z.object({
    workplaceIds: zod_1.z.array(zod_1.z.uuid()).min(1),
});
exports.approvalChainStepDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    sira: zod_1.z.number().int(),
    ad: zod_1.z.string().min(1),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES),
    izinVeren: zod_1.z.boolean(),
    // K1.4 (tur 10): kurulumun görünür hâli — gerekçe shared-types'ta.
    havuzSayisi: zod_1.z.number().int().min(0),
    tamKapsayanSayisi: zod_1.z.number().int().min(0),
});
exports.approvalChainDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    izinTuruRefId: zod_1.z.uuid().nullable(),
    ad: zod_1.z.string().min(1),
    steps: zod_1.z.array(exports.approvalChainStepDetailSchema),
});
/**
 * TALEP AÇMA — v1 asgari gövde (F3·S2). Talep formunun tam yüzü (katılımcı,
 * tür, JSA, ekipman) S4'ündür; buradaki alanlar onay zincirinin
 * çözümlenebilmesi için ZORUNLU olan çekirdektir: izin lokasyonu havuzu
 * belirler (ERD §5.5), geçerlilik aralığı süre dolumunu besler.
 */
exports.ptwPermitCreateSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    locationId: zod_1.z.uuid(),
    gecerlilikBaslangic: zod_1.z.iso.datetime(),
    gecerlilikBitis: zod_1.z.iso.datetime(),
    /**
     * F3·S3 genişlemesi — UYGUNLUĞUN GİRDİLERİ. Üçü de opsiyoneldir (talep
     * taslak olarak açılıp doldurulabilir); formun tam YÜZÜ (JSA, önlemler,
     * KKD, ekran) S4'ündür — buradaki alanlar uygunluk motorunun okuduğu
     * çekirdektir:
     *  - `izinTuruRefIds` : yetkinlik şartının (izin_turu, gorev) ekseni
     *  - `katilimcilar`   : (kişi, görev) ÇİFTİ — şart göreve asılır
     *  - `ekipmanIds`     : 1 gün marjının hedefi
     *  - `guncelSorumluEmploymentId`: K1 — aktife geçişi/devri o yürütür
     */
    izinTuruRefIds: zod_1.z.array(zod_1.z.uuid()).optional(),
    katilimcilar: zod_1.z.array(zod_1.z.object({ personId: zod_1.z.uuid(), gorevRefId: zod_1.z.uuid() })).optional(),
    ekipmanIds: zod_1.z.array(zod_1.z.uuid()).optional(),
    guncelSorumluEmploymentId: zod_1.z.uuid().nullish(),
});
/**
 * K-95c (16.09.2026 — bulgu 95): taslakta güncel sorumlu seçimi. Sorumlu
 * GÖNDERİMDE zorunlu olduğu için taslakta seçilebilmesi gerekir; yoksa formda
 * boş bırakılan taslak ne gönderilir ne düzeltilirdi (§2.40).
 */
exports.ptwSorumluSetSchema = zod_1.z.object({ guncelSorumluEmploymentId: zod_1.z.uuid() });
exports.ptwPermitSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    locationId: zod_1.z.uuid(),
    locationAd: zod_1.z.string().min(1),
    talepEdenAd: zod_1.z.string().min(1),
    durum: exports.ptwDurumSchema,
    superDurum: exports.ptwSuperDurumSchema,
    gecerlilikBaslangic: zod_1.z.iso.datetime(),
    gecerlilikBitis: zod_1.z.iso.datetime(),
    /** K5 (tur 10): tür ÇOKLUDUR — liste kolonu diziden çizilir. */
    izinTurleri: zod_1.z.array(zod_1.z.string().min(1)),
    /** K7 damgası — TÜRETİLMİŞ (açık ihlal kaydı var mı); kolon değil. */
    kararBekliyor: zod_1.z.boolean(),
});
exports.ptwPendingApprovalSchema = zod_1.z.object({
    permit: exports.ptwPermitSummarySchema,
    chainStepId: zod_1.z.uuid(),
    stepAd: zod_1.z.string().min(1),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES),
    izinVeren: zod_1.z.boolean(),
    kapi: exports.ptwOnayKapiSchema,
    turNo: zod_1.z.number().int().min(1),
});
/** Onay sonucu — ÜÇ seçenek (Kapsam §16.7.2); kapalı liste. */
exports.PTW_ONAY_SONUCLARI = ['approved', 'revision_requested', 'rejected'];
exports.ptwOnaySonucSchema = zod_1.z.enum(exports.PTW_ONAY_SONUCLARI);
/**
 * MADDE 49 (✅ 12.08.2026 — Kapsam §16.7.2): üç sonuçtan **revizyon iste** ve
 * **red** GEREKÇE İSTER (serbest metin, zorunlu); **onayda istenmez.**
 * Gerekçesiz revizyon talep sahibini, gerekçesiz red raporu kör bırakır.
 *
 * Kural TEK CÜMLEDİR ve tek yerde durur: aşağıdaki yüklem hem uç şemasının
 * (`ptwApprovalDecisionSchema`) hem motorun (`decidePtwApproval`) kapısıdır —
 * ikinci bir "hangi sonuçta gerekçe ister" listesi yazılmaz. Veri düzeyindeki
 * kilit DB CHECK'tir (`ptw_approval_gerekce_zorunlu` — ERD v0.27 §5.5
 * yerleşim kararı: `sonuc` + `gerekce` AYNI satırın iki kolonu, dolayısıyla
 * CHECK mümkün; "Diğer → serbest metin" kuralından farkı budur).
 */
function ptwOnayGerekcesiZorunluMu(sonuc) {
    return sonuc !== 'approved';
}
/**
 * MADDE 240 (bulgu 71): aynı kişi + görev çifti izne AYNI ANDA iki kez
 * yazılırsa (çift tık · iki sekme) veritabanının kısmi unique'i ikincisini
 * reddeder — kayıt durumu çatışmasıdır (409), sunucu arızası değil. Metin
 * kullanıcıya ne olduğunu ve ne yapacağını söyler (D2).
 */
exports.PTW_KATILIMCI_CAKISMA_METNI = 'Bu kişi bu görevle izne zaten eklenmiş — sayfayı yenileyip listeyi kontrol edin.';
exports.PTW_ONAY_GEREKCE_ZORUNLU_MESAJI = 'Revizyon ve red kararı gerekçe ister (Kapsam §16.7.2 — onaylanan iş ile ' +
    'revize edilen iş aynı iş değildir; gerekçe talep sahibine ve rapora yazılır)';
/**
 * Karar gövdesi — gerekçe kuralı `ptwOnayGerekcesiZorunluMu` ile bağlı.
 *
 * `kapi` F3·S4'te GELDİ ve varsayılanı `acilis`tir (S2 çağrıları aynen
 * çalışır). Uzatma ve kapanış AYNI uçtan, AYNI motordan geçer — İKİNCİ KARAR
 * YOLU YAZILMAZ (§2.6d). Hangi kapının hangi durumda açık olduğu motorda
 * (KAPI_DURUMLARI) tektir; şema kapıyı yalnız taşır, doğrulamaz.
 */
exports.ptwApprovalDecisionSchema = zod_1.z
    .object({
    kapi: exports.ptwOnayKapiSchema.default('acilis'),
    sonuc: exports.ptwOnaySonucSchema,
    gerekce: zod_1.z.string().trim().min(1).max(2000).nullish(),
})
    .superRefine((deger, ctx) => {
    if (ptwOnayGerekcesiZorunluMu(deger.sonuc) && !deger.gerekce) {
        ctx.addIssue({
            code: 'custom',
            path: ['gerekce'],
            message: exports.PTW_ONAY_GEREKCE_ZORUNLU_MESAJI,
        });
    }
});
exports.ptwApprovalDecisionResultSchema = zod_1.z.object({
    permit: exports.ptwPermitSummarySchema,
    kapi: exports.ptwOnayKapiSchema,
    turNo: zod_1.z.number().int().min(1),
    sonuc: exports.ptwOnaySonucSchema,
    turTamamlandi: zod_1.z.boolean(),
    bekleyenBasamaklar: zod_1.z.array(zod_1.z.string()),
});
exports.approvalChainContractIsInSync = true;
exports.ptwKatilimciKararBekleyenContractIsInSync = true;
exports.ptwPermitSummaryContractIsInSync = true;
exports.ptwPendingApprovalContractIsInSync = true;
exports.ptwApprovalDecisionContractIsInSync = true;
// ── F3·S3: uygunluk motoru + K7 ihlal akışı ──────────────────────────────────
//
// Kapsam §16.5 (1 gün marjı · periyodik ≠ operasyonel) + §16.7.5 (anlık =
// canlı, TEK mekanizma) + §5.13 (yüklenici saha girişi) + §19/11 (sözlük
// kural ekseni: `izinde_aranir` / `on_kosul`) + K7 (ihlal kararı).
/**
 * ERD §5 `ptw_eligibility.kontrol_tipi` — motorun BEŞ BACAĞI.
 *
 * `health` F3B·S8'den beri ÜRETİLİR (§16.11/11 — sağlık bacağı); "v1'de
 * üretilmez" şerhi o turda düştü.
 *
 * ⚠️ **RİSK BACAĞI YOKTUR ve eklenmez (R8 — Kapsam §16.12/11):** risk KAPSAM
 * bazlı, izin İŞ bazlıdır; zorlanırsa SAHTE BİR KAPI olurdu. Bu liste
 * `packages/db/src/ptw-eligibility.spec.ts`teki **tam eşitlik kanaryasıyla**
 * kilitlidir — altıncı bacak eklemek ürün kararıdır ve testi kırar.
 */
exports.PTW_UYGUNLUK_KONTROL_TIPLERI = [
    'training',
    'health',
    'equipment',
    'contractor',
    // F3·S6 — tür→zorunlu görev matrisi (Kapsam §19/14): hedefi KİŞİ değil,
    // iznin KATILIMCI BİLEŞİMİDİR. `training` altına sokulmadı — düzeltmesi
    // belge almak değil, katılımcı eklemektir.
    'participant',
];
exports.ptwUygunlukKontrolTipiSchema = zod_1.z.enum(exports.PTW_UYGUNLUK_KONTROL_TIPLERI);
/**
 * Uygunsuzluk KURAL kodları — kapalı liste. Kayda KOD yazılır, cümle yazılmaz:
 * aynı kod iç sözlükte ve portal sözlüğünde farklı cümleye çevrilir (D2 —
 * `PORTAL_SATIR_MESAJLARI` deseninin PTW kolu).
 */
exports.PTW_UYGUNLUK_KURALLARI = [
    // Katılımcının (kişi, görev) çiftine asılı yetkinlik şartı hiç yok.
    'yetkinlik_yok',
    // ✏️ K-72 (14.09.2026 — bulgu 72): `on_kosul` (temel İSG) kalemi HİÇ yok.
    // AYRI kod, çünkü ÇARESİ FARKLI: dış belge değil EĞİTİM KAYDIDIR — elle
    // yetkinlik ucu `egitim_turu` kalemini reddeder (400), kayıt eğitim
    // modülünden doğar. `yetkinlik_yok`un "belgeyi kişi dosyasına ekleyin"
    // çaresi bu kalemde YALAN olurdu (D2 — ne yapılacağını doğru söyler).
    'temel_isg_egitimi_yok',
    // Yetkinlik var ama geçerlilik tarihi geçmiş (bitiş günü DAHİL geçerli).
    'yetkinlik_suresi_doldu',
    // ✏️ K9 (tur 5): yetkinlik var ama BAŞLANGICI GELECEKTE — bugün taşınmaz.
    // Kapıyı AÇMAZ; okuyucu `@isg/validation yetkinlikVadeDurumu` (tek yüklem).
    'yetkinlik_henuz_gecerli_degil',
    // Temel İSG (`on_kosul`) — kişinin GÜNCEL işe girişinden ÖNCE alınmış:
    // taşınabilir yetkinlik kuralının kayıt-tipi bazlı istisnası (§2.11).
    'yetkinlik_istihdam_oncesi',
    // K3'ün ikinci yarısı: izin veren basamağını onaylayanın iş izin sistemi
    // eğitimi — şart (izin_turu, "izin veren" görevi) çiftine asılıdır (ERD §5.3).
    'izin_veren_egitimi',
    // Kontrol tarihi bilinmiyor → sistem "uygundur" DİYEMEZ (fail-closed, §2.4).
    'ekipman_kontrol_tarihi_bilinmiyor',
    // 1 GÜN MARJI (§16.5): sonraki_kontrol > now + 1 gün olmalı.
    'ekipman_marji',
    // ── K3 (tur 4) — EKİPMAN DURUMU: UYARI, ENGEL DEĞİL ────────────────────
    // İzin açıkken ekipman PASİFE alınırsa kalem üretilir ama `uygun: true`
    // kalır (`saglik_farkli_isyeri`nin ikinci üyesi — *"engelleme, görünür
    // kıl"*). Gerekçe: pasiflik bir KONTROL EKSİKLİĞİ değil bir KULLANIM
    // KARARIDIR; sert kapı olsaydı depoya çekilen bir yedek ekipman yüzünden
    // SÜREGELEN İŞ durdurulurdu. Seçim havuzu pasif ekipmanı zaten hiç
    // göstermez (`aktifEkipmanFiltresi`) — değişen yalnız izin AÇILDIKTAN
    // SONRASIDIR (§16.7.5 canlı bağın ekipman ayağı).
    'ekipman_pasif',
    // Saha girişi (§5.13): firmanın o tipte geçerli evrakı yok.
    'saha_giris_evraki',
    // MÜŞTERİ MATRİSİ (§19/14): izin türünün zorunlu tuttuğu görevi taşıyan
    // katılımcı yok. Kütüphane bunu DAYATMAZ — kural yalnız müşteri satır
    // yazdıysa işler; matris boşken bu kalem HİÇ ÜRETİLMEZ.
    'zorunlu_gorev_eksik',
    // ── F3B·S8 — SAĞLIK BACAĞI (Kapsam §16.11/11) ──────────────────────────
    // Kanaat hiç yok → fail-closed: sistem, sağlık durumunu bilmediği kişiye
    // "uygundur" diyemez (ekipman `kontrol_tarihi_bilinmiyor` deseni).
    'saglik_kanaati_yok',
    // Kanaat var ama vadesi dolmuş → KAPI (S6; yetkinlik ve ekipman marjıyla
    // AYNI davranış — üç eksen tek kural).
    'saglik_kanaati_suresi_doldu',
    // Kanaatin kararı "Uygun değildir" → KAPI. Kararın SINIFI motorca okunur
    // (`karar_sinifi`), bu yüzden `uygunluk_karari` sözlüğü KAPALI listedir.
    'saglik_uygun_degil',
    // Kısıt bu izin türünü / izin içi görevi engelliyor → KAPI (S5).
    'saglik_kisiti',
    // R8: RİSK DEĞERLENDİRME BACAĞI YOKTUR ve eklenmez — risk KAPSAM bazlı,
    // izin İŞ bazlıdır; zorlanırsa SAHTE BİR KAPI olurdu (Kapsam §16.12/11).
    // Kanaat FARKLI bir işyeri için verilmiş → **UYARI, ENGEL DEĞİL** (S3:
    // "engelleme, görünür kıl"). Tek `uyari: true` kalemi budur.
    'saglik_farkli_isyeri',
    // ── F3B·S8 — T7 KAPILARI (Kapsam §16.10/8; madde 69/C) ─────────────────
    // Md. 18: 6 ay+ ara verip dönen kişiye bilgi yenileme eğitimi. Kapı
    // **izin açılışındadır**, saha girişini ENGELLEMEZ (T7 doz şerhi).
    'bilgi_yenileme_gerekli',
    // Md. 19: kaza geçiren kişiye işe dönüşte ilave eğitim.
    'ilave_egitim_gerekli',
];
exports.ptwUygunlukKuralSchema = zod_1.z.enum(exports.PTW_UYGUNLUK_KURALLARI);
exports.ptwUygunlukKalemiSchema = zod_1.z.object({
    kontrolTipi: exports.ptwUygunlukKontrolTipiSchema,
    kural: exports.ptwUygunlukKuralSchema,
    hedefRef: zod_1.z.uuid().nullable(),
    kalem: zod_1.z.string().min(1),
    uygun: zod_1.z.boolean(),
    /**
     * UYARI KALEMİ — F3B·S8 (S3). `uygun: true` ama dikkat çeker: iznin
     * açılmasını **BLOKLAMAZ**, ekranda görünür ("engelleme, görünür kıl").
     * Bugünkü tek üyesi `saglik_farkli_isyeri`dir. Bir kalemi hem `uygun:
     * false` hem `uyari: true` yapma — o zaman kapı mı uyarı mı belirsizleşir.
     */
    uyari: zod_1.z.boolean().default(false),
    mesaj: zod_1.z.string().min(1),
    neYapilmali: zod_1.z.string().min(1),
});
exports.ptwUygunlukSonucuSchema = zod_1.z.object({
    permitId: zod_1.z.uuid(),
    uygun: zod_1.z.boolean(),
    /** Dilim 2 / madde 239 — rozetin kaynağı (`ptwUygunlukDurumu`): boş ≠ uygun. */
    durum: ptw_kontrol_matrisi_1.ptwUygunlukDurumuSchema,
    kalemler: zod_1.z.array(exports.ptwUygunlukKalemiSchema),
    /** ✏️ K-96 — kalem üretmeyen aileler; boş liste metni sebebi buradan söyler. */
    kapaliAileler: zod_1.z.array(ptw_kontrol_matrisi_1.ptwKontrolAilesiSchema),
});
/**
 * ONAY KAPISININ UYGUNLUK OKUMASI — P-2/P-5 (28.08.2026, PTW yüzey turu).
 *
 * ⚠️ İKİ AYRI KONTROL, İKİ AYRI BAŞLIK (P-5 / madde 125). Onay penceresinde
 * tek bir "UYGUN" rozeti bugüne kadar İKİSİNİ birden temsil ediyormuş gibi
 * duruyordu ve kullanıcı üstte yeşil, altta kırmızı görüp çelişki sanıyordu:
 *  · `izin`      → İZNİN uygunluğu (katılımcı yetkinliği · ekipman marjı ·
 *                  sağlık kanaati · yüklenici evrakı),
 *  · `onaylayan` → ONAYLAYANIN yetkinliği (K3 — "iş izin sistemi eğitimi").
 *                  YALNIZ izin veren basamağında koşar; başka basamakta
 *                  `null`dur (kural o basamağa asılıdır, ERD §5.3).
 *
 * `engeller` ikisinin uygunsuzlarının BİRLEŞİMİDİR ve kapı kuralını (hangi
 * onay kapısında bloklandığı) ZATEN İÇERİR — ekran ikinci kural yazmaz:
 * düğme `engeller.length > 0` ise pasiftir, uç da aynı listeyle 422 verir.
 */
exports.ptwOnayUygunluguSchema = zod_1.z.object({
    kapi: exports.ptwOnayKapiSchema,
    /** Bu basamak izin veren mi (onaylayan bölümünün varlık sebebi). */
    izinVeren: zod_1.z.boolean(),
    izin: exports.ptwUygunlukSonucuSchema,
    onaylayan: exports.ptwUygunlukSonucuSchema.nullable(),
    /** Onayı BLOKLAYAN kalemler — boşsa "Kararı kaydet" açıktır. */
    engeller: zod_1.z.array(exports.ptwUygunlukKalemiSchema),
});
/**
 * P-3 (28.08.2026 — madde 123): AYNI ZİNCİRDE İKİ BASAMAK AYNI ADI TAŞIYAMAZ.
 *
 * Kural ÜÇ KATMANIN da işine yarar (ekran düğmeyi kapatır, uç 422 verir,
 * motor kaydı reddeder) — bu yüzden evi `@isg/validation`dır.
 *
 * ⚠️ SERBEST METİN İLKESİ KORUNUR: basamak adı müşterinin kendi prosedür
 * dilidir; engellenen tek şey ÇAKIŞMADIR. Çakışırsa onaycının "bekleyen
 * onaylarım" listesinde iki ÖZDEŞ satır belirir ve hangisine imza attığı
 * ekrandan okunamaz — imza basamağa bağlıdır, ad ise tek görünür ayırt
 * edicisidir.
 *
 * Karşılaştırma GÖRSEL farkları yok sayar (baş/son boşluk · iç boşluk ·
 * büyük-küçük harf, `tr` yerelinde — I/İ ayrımı): kullanıcı iki satırı
 * ayırt edemiyorsa sistem de ayırt etmiş sayılmaz.
 */
function basamakAdAnahtari(ad) {
    return ad.trim().replace(/\s+/g, ' ').toLocaleLowerCase('tr');
}
function cakisanBasamakAdlari(steps) {
    const sayac = new Map();
    for (const step of steps) {
        const key = basamakAdAnahtari(step.ad);
        if (key === '')
            continue;
        const kayit = sayac.get(key);
        if (kayit)
            kayit.adet += 1;
        else
            sayac.set(key, { ad: step.ad.trim(), adet: 1 });
    }
    return [...sayac.values()].filter((k) => k.adet > 1).map((k) => k.ad);
}
/**
 * KATILIMCI LİSTESİNİ YAZ — GÖNDERİLEN LİSTE TAM LİSTEDİR (`setTrainingKonular`
 * deseni). Kısmi ekleme/çıkarma ucu açılmadı: iki uç olsaydı ekran hangisini
 * çağıracağına karar vermek zorunda kalır ve "sildim ama duruyor" sınıfı
 * hatalar doğardı.
 *
 * BOŞ LİSTE GEÇERLİDİR — taslak serbesttir (S8-3 deseni); kilit yalnız
 * GÖNDERİMDEDİR (P-1).
 */
exports.ptwParticipantsSetSchema = zod_1.z.object({
    katilimcilar: zod_1.z.array(zod_1.z.object({ personId: zod_1.z.uuid(), gorevRefId: zod_1.z.uuid() })),
});
// ── İTA — İŞ TEHLİKE ANALİZİ (tur 11 / R6; Kapsam §16.7.4/6) ───────────────
/**
 * İTA SATIRI: **ADIM → TEHLİKE → ÖNLEM**, sıralı.
 *
 * ⚠️ **SORUMLU ALANI YOKTUR ve SKOR ALANI YOKTUR** (§16.7.4/6-1): sorumluluk
 * iznin kendi zincirindedir (onaylayan · güncel sorumlu · katılımcı görevi),
 * skor risk modülünün metodolojik işidir (§16.12). İkisini de buraya koymak
 * iznin içinde **ikinci bir takip yolu** ve **ikinci bir ölçek** doğururdu.
 *
 * ⚠️ **KÜTÜPHANE REFERANSI YOKTUR:** üç alan da serbest metindir ve
 * **her izinde SIFIRDAN yazılır** — ön doldurma analizi bir **talimata**
 * çevirirdi (§16.7.4/6-2). Kopyalama da satır taşımaz.
 */
exports.ptwJsaSatirSchema = zod_1.z.object({
    isAdimi: zod_1.z.string().trim().min(1).max(500),
    tehlike: zod_1.z.string().trim().min(1).max(500),
    onlem: zod_1.z.string().trim().min(1).max(1000),
});
/**
 * GÖNDERİLEN LİSTE TAM LİSTEDİR (`ptwParticipantsSetSchema` deseni) ve
 * **SIRA DİZİNİN KENDİSİDİR** — ayrı bir `sira` alanı istenmez, çünkü iki
 * kaynaklı sıra (dizi + alan) bir gün ayrışır.
 *
 * ⚠️ **BOŞ LİSTE GEÇERLİDİR:** İTA zorunlu değildir (§16.7.4/6-3) — boş İTA
 * onaya gidebilir ve **onaycı reddeder.** Zorunlu alan, doldurulması gereken
 * bir kutuya dönüşür ve tek satırlık *"dikkatli çalışılacak"* yazılır.
 */
exports.ptwJsaSetSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.ptwJsaSatirSchema).max(200),
});
exports.ptwJsaRowSchema = exports.ptwJsaSatirSchema.extend({
    id: zod_1.z.uuid(),
    sira: zod_1.z.number().int(),
});
/**
 * SÖZLÜK KURAL EKSENİ — okuma sözleşmeleri (Kapsam §19/11; eksen SONRADAN
 * EKLENEMEZ, içerik eklenebilir). `readUyariEsigiGun` deseni: bozuk değer
 * taramayı DÜŞÜRMEZ, o kalem kuralsız sayılır.
 *
 * `izinde_aranir: { izin_turu, gorev }` — yetkinlik şartı izne değil izin içi
 * GÖREVE asılır. `izin_turu` null/eksik = her türde aranır; `gorev` zorunlu
 * (şartın asıldığı eksen odur). Değerler tenant NÜSHASININ uuid'leridir
 * (lookup nüsha modeli — global satır yok).
 */
exports.izindeAranirSchema = zod_1.z.object({
    izin_turu: zod_1.z.uuid().nullish(),
    gorev: zod_1.z.uuid(),
});
function readIzindeAranir(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return null;
    const deger = kurallar['izinde_aranir'];
    const parsed = exports.izindeAranirSchema.safeParse(deger);
    return parsed.success ? parsed.data : null;
}
/**
 * `on_kosul: true` — izin türünden ve görevden BAĞIMSIZ şart (temel İSG
 * eğitimi): her katılımcıya uygulanır. İzin-bazlı yazılsaydı her yeni izin
 * türünde biri unutulurdu (Kapsam §19/11-2).
 */
function readOnKosul(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return false;
    return kurallar['on_kosul'] === true;
}
/** K7 ihlal kararı gövdesi. `surdur` gerekçe İSTER (kayıtlı, raporda görünür);
 *  `geri_cek`te gerekçe kodu VERİLMEZSE uygunsuzluk kaleminden OTOMATİK düşer
 *  (K9) — izin veren üstüne yazabilir. */
exports.ptwViolationDecisionSchema = zod_1.z
    .object({
    karar: exports.ptwIhlalKararSchema,
    gerekce: zod_1.z.string().trim().min(1).max(2000).nullish(),
    gerekceRefId: zod_1.z.uuid().nullish(),
    gerekceMetin: zod_1.z.string().trim().min(1).max(2000).nullish(),
})
    .superRefine((deger, ctx) => {
    if (deger.karar === 'surdur' && !deger.gerekce) {
        ctx.addIssue({
            code: 'custom',
            path: ['gerekce'],
            message: 'Sürdürme kararı gerekçe ister (K7 — gerekçe kayıtlıdır ve raporda görünür; ' +
                'sık "sürdür" kararı bulgudur)',
        });
    }
});
exports.ptwViolationSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    permit: exports.ptwPermitSummarySchema,
    kontrolTipi: exports.ptwUygunlukKontrolTipiSchema,
    kural: exports.ptwUygunlukKuralSchema,
    kalem: zod_1.z.string().min(1),
    mesaj: zod_1.z.string().min(1),
    neYapilmali: zod_1.z.string().min(1),
    bildirimAt: zod_1.z.iso.datetime(),
    onerilenGerekceRefId: zod_1.z.uuid().nullable(),
});
exports.ptwEquipmentScanContractIsInSync = true;
exports.ptwQrDurumContractIsInSync = true;
exports.ptwUygunlukSonucuContractIsInSync = true;
exports.ptwViolationSummaryContractIsInSync = true;
// ── F3·S4: ofis/web yüzeyinin sözleşmeleri (Kapsam §16.7, ERD §5.5) ─────────
/** Geri çekilme gövdesi (K2/S0-K1). "Diğer" kaleminde serbest metin ZORUNLU
 *  ama kural SERVİSTEDİR (`withdrawPtwPermit`): zorunluluk cevabı BAŞKA
 *  TABLONUN satırındadır (`lookup_item.kutuphane_ref`), şema onu göremez —
 *  madde 49'un DB CHECK'inden farkı tam olarak budur. Şema yalnız biçim
 *  denetler; ikinci bir "Diğer mi" listesi tutulmaz. */
exports.ptwWithdrawSchema = zod_1.z.object({
    gerekceRefId: zod_1.z.uuid(),
    gerekceMetin: zod_1.z.string().trim().min(1).max(2000).nullish(),
});
/**
 * UZATMA TALEBİ (madde 52 ✅ 13.08.2026 — Kapsam §16.7.2; F3·S5 ön adımı).
 * Uzatma bir durum değil KAYITTIR: kim (sunucuda — güncel sorumlunun
 * istihdamı) · **yeni bitiş** · **gerekçe**.
 *
 * GEREKÇE ZORUNLU ve SERBEST METİNDİR (madde 49 sınıfı): sürekli uzatma
 * denetimi kayıtsız yapılamaz. K9 sözlüğüne BAĞLANMAZ — o sözlük sahadaki
 * tek tuşluk geri çekilme kararına aittir. Yeni bitişin iznin mevcut
 * bitişinden sonra olması kuralı SERVİSTEDİR (karşılaştırılacak değer
 * kaydın kendisindedir, şema onu göremez).
 */
exports.ptwExtensionRequestSchema = zod_1.z.object({
    yeniBitis: zod_1.z.iso.datetime(),
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
/** İptal (matris satır 2) — gerekçe İSTEĞE BAĞLI: iptal talep edenin kendi
 *  geri adımıdır, onaycının kararı değildir (red ile karıştırma — §2.6/K13). */
exports.ptwCancelSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(1).max(2000).nullish(),
});
// ── F3·S5: SAHA YÜZEYİ + CACHE-AND-QUEUE (T2 envanteri · K11 · K5/K6) ───────
/**
 * CİHAZ SAATİ — çevrimdışı kuyruğa alınan saha adımının cihazdaki anı.
 * Sunucu kendi saatini AYRICA yazar (`created_at`); iz İKİ SAATLİDİR.
 * İsteğe bağlıdır: çevrimiçi işlemde gönderilmez ve null kalır.
 *
 * KUYRUK KAPSAMI KİLİTLİ (Kapsam §16.7 saha yüzeyi kararı): yalnız KAPANIŞ
 * YÖNLÜ, güvenli adımlar kuyruklanır — askı al · kişisel kilit as/çıkar ·
 * izolasyon işaretleme · "işim bitti" · ekipman teyit taraması. İzni AÇAN ya
 * da CANLANDIRAN adımlar (işbaşı doğrulaması · askıdan dönüş · devir kabulü ·
 * geri çekilme) çevrimiçi ister: bayat veriyle riskli yönde işlem yapılmaz.
 */
const cihazAtAlani = zod_1.z.iso.datetime().optional();
exports.ptwCihazAtSchema = zod_1.z.object({ cihazAt: cihazAtAlani });
/** Askıya alma (matris satır 5) — askı EKİBİN duraksamasıdır (S0-K2). */
exports.ptwSuspendSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(1).max(2000).nullish(),
    cihazAt: cihazAtAlani,
});
/** Devir başlatma (K1) — devralan İSTİHDAM referansıdır (kişi ≠ istihdam). */
exports.ptwHandoverStartSchema = zod_1.z.object({ devralanEmploymentId: zod_1.z.uuid() });
/** İzolasyon noktası (K5) — LOTO ayrı kayıttır, iznin alanı değildir. */
exports.ptwIsolationCreateSchema = zod_1.z.object({
    izolasyonNoktasi: zod_1.z.string().trim().min(1).max(200),
    kilitNo: zod_1.z.string().trim().min(1).max(60).nullish(),
    etiketNo: zod_1.z.string().trim().min(1).max(60).nullish(),
    cihazAt: cihazAtAlani,
});
/**
 * Kişisel kilit çıkarma (K6): kural KİLİDİ TAKAN KALDIRIR. `zorla` istisna
 * yoludur ve ÜÇÜ BİRLİKTE ister (izin veren onayı + gerekçe + kim kesti) —
 * DB CHECK de zorlar (`ptw_isolation_lock_zorla_butunlugu`), şema burada
 * yalnız üçlünün birlikte geldiğini denetler.
 */
exports.ptwIsolationLockRemoveSchema = zod_1.z.object({
    zorla: zod_1.z
        .object({
        onaylayanPersonId: zod_1.z.uuid(),
        gerekce: zod_1.z.string().trim().min(1).max(2000),
        kesenPersonId: zod_1.z.uuid(),
    })
        .nullish(),
    cihazAt: cihazAtAlani,
});
/** K11 — ekipman kimlik teyidi: OPSİYONEL tarama, işbaşını BLOKLAMAZ. */
exports.ptwEquipmentScanSchema = zod_1.z.object({
    kod: zod_1.z.string().trim().min(1).max(200),
    cihazAt: cihazAtAlani,
});
exports.ptwEquipmentScanSonucuSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    tarananKod: zod_1.z.string().min(1),
    eslesti: zod_1.z.boolean(),
    ekipmanAd: zod_1.z.string().nullable(),
    taramaAt: zod_1.z.iso.datetime(),
    /** K8 dili — sonucun cümlesi SUNUCUDAN gelir (ekran ikinci sözlük tutmaz). */
    mesaj: zod_1.z.string().min(1),
});
/**
 * QR sayfasının salt-okunur durum kartı. Kimliksiz erişim YOKTUR (401) —
 * QR yalnız ADRES taşır, veriyi oturum açar.
 *
 * MADDE 54 (F3·S6 ön adımı): şema DAR ve KİMLİK VERİSİZDİR — tür · durum ·
 * geçerlilik · lokasyon. Ad alanları çıkarıldı; şema `strict` olduğu için
 * uçtan kaçak bir ad alanı geri sızsa **parse'ta düşer** (maskeli kimlik
 * deseninin QR kolu — §2.16). Alan eklemek ürün kararıdır.
 */
exports.ptwQrDurumSchema = zod_1.z
    .object({
    id: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    locationAd: zod_1.z.string().min(1),
    izinTurleri: zod_1.z.array(zod_1.z.string().min(1)),
    durum: exports.ptwDurumSchema,
    superDurum: exports.ptwSuperDurumSchema,
    gecerlilikBaslangic: zod_1.z.iso.datetime(),
    gecerlilikBitis: zod_1.z.iso.datetime(),
})
    .strict();
/** Özetin ALAN ENVANTERİ — daralmanın testi bu listeden okur; yeni alan
 *  eklemek testi kırar ve kararı açıkça verdirir (envanter testi deseni). */
exports.PTW_QR_OZET_ALANLARI = [
    'id',
    'workplaceAd',
    'locationAd',
    'izinTurleri',
    'durum',
    'superDurum',
    'gecerlilikBaslangic',
    'gecerlilikBitis',
];
exports.ptwSuperDurumSayaclariSchema = zod_1.z.object({
    hazirlik: zod_1.z.number().int().min(0),
    onayda: zod_1.z.number().int().min(0),
    isbasi_bekliyor: zod_1.z.number().int().min(0),
    sahada: zod_1.z.number().int().min(0),
    kapanista: zod_1.z.number().int().min(0),
    bitti: zod_1.z.number().int().min(0),
});
exports.ptwPermitListResponseSchema = zod_1.z.object({
    sayaclar: exports.ptwSuperDurumSayaclariSchema,
    permits: zod_1.z.array(exports.ptwPermitSummarySchema),
    /** K5 (tur 10) — süzgeç sonrası, SEKME DAHİL sayı. */
    toplam: zod_1.z.number().int().min(0),
    sayfa: zod_1.z.number().int().min(1),
    sayfaBoyutu: zod_1.z.number().int().min(1),
});
exports.BOS_PTW_IZIN_SUZGECI = {
    // Varsayılan sekme SAHADA: ofis kullanıcısının ilk sorusu *"şu an sahada ne
    // var"*dır (F3·S4 kararı, ekrandan buraya taşındı).
    superDurum: 'sahada',
    workplaceId: null,
    izinTuruRefId: null,
    baslangicDan: null,
    bitisEKadar: null,
    talepEdenPersonId: null,
    sayfa: 1,
};
exports.PTW_SAYFA_BOYUTU = 25;
function ptwIzinSuzgecSorgusu(suzgec, sayfalama) {
    const sorgu = new URLSearchParams();
    if (suzgec.superDurum)
        sorgu.set('superDurum', suzgec.superDurum);
    if (suzgec.workplaceId)
        sorgu.set('workplaceId', suzgec.workplaceId);
    if (suzgec.izinTuruRefId)
        sorgu.set('izinTuruRefId', suzgec.izinTuruRefId);
    if (suzgec.baslangicDan)
        sorgu.set('baslangicDan', suzgec.baslangicDan);
    if (suzgec.bitisEKadar)
        sorgu.set('bitisEKadar', suzgec.bitisEKadar);
    if (suzgec.talepEdenPersonId)
        sorgu.set('talepEdenPersonId', suzgec.talepEdenPersonId);
    if (sayfalama)
        sorgu.set('sayfa', String(suzgec.sayfa));
    const dizge = sorgu.toString();
    return dizge === '' ? '' : `?${dizge}`;
}
/**
 * ⚠️ **SEKME SAYILMAZ.** Süzgeç göstergesi (*"2 süzgeç etkin · temizle"*)
 * yalnız kullanıcının EKLEDİĞİ daralmaları sayar; sekme zaten ekranda görünür
 * ve her zaman biri seçilidir — sayılsaydı gösterge hiç sıfırlanmazdı.
 */
function etkinPtwSuzgeciSayisi(suzgec) {
    return [
        suzgec.workplaceId,
        suzgec.izinTuruRefId,
        suzgec.baslangicDan,
        suzgec.bitisEKadar,
        suzgec.talepEdenPersonId,
    ].filter((v) => v !== null).length;
}
/** K5 — liste süzgecinin havuzları (talep formunun havuzundan AYRI uç). */
exports.ptwPermitFilterOptionsSchema = zod_1.z.object({
    isyerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    izinTurleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    talepEdenler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
});
/**
 * ✏️ **GEZİNTİ ARTÇISI 2 / B2.2 — TASLAK İÇERİĞİNİN KİLİDİ VE SEBEBİ.**
 *
 * İTA ve katılımcı listesi AYNI yüklemle yazılır (taslak ∧ talep eden); bu
 * fonksiyon o yüklemin **tek yeridir** ve düzenlenemiyorsa **nedenini** de
 * söyler. ⚠️ Ürün sahibinin gezintisi: aktif izinde İTA bölümü *"girilmemiş"*
 * diyor, nedenini söylemiyordu — kullanıcı eksiklik mi kilit mi ayırt
 * edemiyordu (§2.40). Bayrak ile sebep iki yerde ayrı hesaplansaydı birine
 * eklenen şart diğerine sessizce eklenmezdi.
 *
 * ⚠️ **SIRA BİLİNÇLİ: DURUM KİMLİKTEN ÖNCE.** Onaya gitmiş izinde talep eden
 * için de sebep *"kilitli"*dir, *"yazamazsın"* değil.
 * ⚠️ **POZİTİF KOŞUL:** yalnız `draft` açıktır; yeni bir durum token'ı
 * eklendiğinde kilitli tarafa düşer (0b — negatif koşul sessizce açardı).
 */
exports.PTW_TASLAK_ICERIK_KILITLERI = [
    'taslak_degil',
    'reddedildi',
    'iptal_edildi',
    'talep_eden_degil',
];
function ptwTaslakIcerikKilidi(durum, talepEden) {
    if (durum === 'draft')
        return talepEden ? null : 'talep_eden_degil';
    if (durum === 'cancelled')
        return 'iptal_edildi';
    if (durum === 'rejected')
        return 'reddedildi';
    return 'taslak_degil';
}
/** İTA kartının kilit cümlesi — D2 dili (iç durum adı metne inmez). */
exports.PTW_ITA_KILIT_METNI = {
    taslak_degil: 'İzin onaya gönderildi; analiz kilitli.',
    reddedildi: 'İzin reddedildi; analiz kilitli.',
    iptal_edildi: 'İzin iptal edildi; analiz kilitli.',
    talep_eden_degil: 'Analizi izni talep eden kişi yazar.',
};
exports.ptwPermitYetkileriSchema = zod_1.z.object({
    gonderebilir: zod_1.z.boolean(),
    iptalEdebilir: zod_1.z.boolean(),
    aktifeGecirebilir: zod_1.z.boolean(),
    /**
     * ✏️ BULGU 95 (16.09.2026 — K-95a revizyonu · P13): aktife geçiş kapısı ve
     * YAZAMAYANIN SEBEBİ. Yalnız izin işbaşı bekliyorken dolu (`null` = düğmenin
     * yeri yok); `aktifeGecirebilir` ile AYNI yüklemden
     * (`@isg/db ptwAktifeGecisEngeli`). Düğmeyi göremeyen kullanıcı nedenini
     * görür — sorumlusuz izinde düğme 32 değil, HİÇ kimsede çizilmiyordu.
     */
    aktifeGecisKapisi: kapi_durumu_1.kapiDurumuSchema.nullable(),
    geriCekebilir: zod_1.z.boolean(),
    uzatmaBaslatabilir: zod_1.z.boolean(),
    isimBittiBildirebilir: zod_1.z.boolean(),
    sahaKontrolYapabilir: zod_1.z.boolean(),
    /** ✏️ K-99 (bulgu 99): saha kontrolü kapısı — `null` = izin saha kontrolü
     *  beklemiyor. Yazamayan kullanıcı tenant `saha_kontrol` şapka listesini
     *  sebep olarak görür (liste sunucudan — istemciye gömülemez). */
    sahaKontrolKapisi: kapi_durumu_1.kapiDurumuSchema.nullable(),
    izinVereni: zod_1.z.boolean(),
    // F3·S5 — SAHA ADIMLARI (T2 envanteri). Hepsi AYNI birleşimden doğar:
    // matriste açık mı (ptwGecisTanimi) ∧ tetikleyen yüklemi doğru mu.
    askiyaAlabilir: zod_1.z.boolean(),
    askidanDonebilir: zod_1.z.boolean(),
    devirBaslatabilir: zod_1.z.boolean(),
    /** İzolasyon kaydı açma: iznin durumu uygun ∧ aktör iznin KATILIMCISI
     *  (madde 53 ✅ 13.08.2026 — `ptwKatilimciMi`; assert'in ikizi). */
    izolasyonEkleyebilir: zod_1.z.boolean(),
    /** ✏️ K-97 (bulgu 97): izolasyon açma kapısı — bayrak ile kişisel sebep
     *  (`@isg/db ptwIzolasyonAcmaEngeli`) aynı yüklemden. */
    izolasyonKapisi: kapi_durumu_1.kapiDurumuSchema,
    /** ✏️ K-98: aktif izne katılımcı ekleme kapısı — `null` = izin aktif değil. */
    katilimciEklemeKapisi: kapi_durumu_1.kapiDurumuSchema.nullable(),
    /** Tür formu doldurma (madde 56 ✅ 14.08.2026 — §22.5/6-a): doldurma şapkası
     *  VEYA SAHİPLİK (talep eden). Doldurma ucunun kapısıyla aynı yüklem. */
    turFormuDoldurabilir: zod_1.z.boolean(),
    /**
     * KATILIMCI DÜZENLEME (P-1 — 28.08.2026): taslak ∧ talep eden. P-1
     * gönderimi katılımcısız izne KAPATTI; kapının açılabilmesi için taslakta
     * katılımcı EKLENEBİLİR olmak zorundaydı — yoksa katılımcısız doğan taslak
     * ölü kayıt olurdu (talep formu katılımcıyı yalnız AÇILIŞTA soruyordu).
     */
    katilimciDuzenleyebilir: zod_1.z.boolean(),
    /**
     * İTA DÜZENLEME (tur 11 / R6): **katılımcı düzenlemesiyle BİREBİR AYNI
     * yüklem** — taslak ∧ talep eden. Yeni bir yetki ekseni AÇILMADI
     * (§16.7.4/6-4): İTA, izin sahibinin kendi taslağını tamamlamasının bir
     * parçasıdır ve ayrı bir yetki, sahibinin kendi analizini yazamadığı bir
     * hâl doğururdu.
     *
     * ⚠️ **KİLİT İZNİN KENDİ DURUM MAKİNESİNE TABİDİR** (§16.7.4/6-5): izin
     * onaya gidince kapanır, revizyon taslağa döndürünce yeniden açılır.
     */
    jsaDuzenleyebilir: zod_1.z.boolean(),
    /**
     * ✏️ Gezinti artçısı 2 / B2.2 — düzenlenemiyorsa NEDEN; bayrakla AYNI
     * yüklemden (`ptwTaslakIcerikKilidi`). `null` ⇔ `jsaDuzenleyebilir`.
     */
    jsaKilitSebebi: zod_1.z.enum(exports.PTW_TASLAK_ICERIK_KILITLERI).nullable(),
});
exports.ptwGecisSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    eskiDurum: exports.ptwDurumSchema,
    yeniDurum: exports.ptwDurumSchema,
    islem: zod_1.z.string().min(1),
    yapanAd: zod_1.z.string().nullable(),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES).nullable(),
    gerekce: zod_1.z.string().nullable(),
    zaman: zod_1.z.iso.datetime(),
});
exports.ptwOnaySatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    kapi: exports.ptwOnayKapiSchema,
    turNo: zod_1.z.number().int().min(1),
    stepAd: zod_1.z.string().min(1),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES),
    izinVeren: zod_1.z.boolean(),
    sonuc: exports.ptwOnaySonucSchema,
    onaylayanAd: zod_1.z.string().nullable(),
    gerekce: zod_1.z.string().nullable(),
    zaman: zod_1.z.iso.datetime(),
    /** PTW onay düğmesi (K-62): satır, kapısının GÜNCEL turundan eskiyse
     *  revizyonla sıfırlanmıştır — kayıt silinmez (§2.9), damga sunucudan. */
    sifirlandi: zod_1.z.boolean(),
});
/**
 * ONAY BASAMAĞI — İZİN SAYFASININ *ONAYLAR* BLOĞU (PTW onay düğmesi,
 * 14.09.2026 — K-62 · K-63 · K-65; Kapsam §16.7 ✏️ · §20.3b P13-d).
 *
 * `karar` gösterilen kapının güncel turundaki karar (yoksa null);
 * `kararKapisi` P13 adım listesinin sonucu (şapka → elle bahçe → durum) —
 * ekran düğmeyi `yazabilir`den, sebebi `<KapiSebebi>`den çizer. İşlerim'in
 * bekleyen onay listesi AYNI olgu kümesinden süzülür (`ptwKararAcikMi`).
 */
exports.ptwOnayBasamagiSchema = zod_1.z.object({
    chainStepId: zod_1.z.uuid(),
    sira: zod_1.z.number().int().min(1),
    stepAd: zod_1.z.string().min(1),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES),
    izinVeren: zod_1.z.boolean(),
    karar: zod_1.z
        .object({
        sonuc: exports.ptwOnaySonucSchema,
        onaylayanAd: zod_1.z.string().nullable(),
        gerekce: zod_1.z.string().nullable(),
        zaman: zod_1.z.iso.datetime(),
    })
        .nullable(),
    kararKapisi: kapi_durumu_1.kapiDurumuSchema,
});
/** Gösterilen kapı + tur + basamaklar; `acik` = bu kapıda karar bekleniyor.
 *  Zincir yoksa detay `null` taşır (ekran zincirsizliği söyler). */
exports.ptwOnayBasamaklariSchema = zod_1.z.object({
    kapi: exports.ptwOnayKapiSchema,
    turNo: zod_1.z.number().int().min(1).nullable(),
    acik: zod_1.z.boolean(),
    basamaklar: zod_1.z.array(exports.ptwOnayBasamagiSchema),
});
/** Kişisel kilit satırı (K5) — `benimMi` sunucuda çözülür: "kilidi TAKAN
 *  kaldırır" kuralının UI karşılığı ekranda yeniden hesaplanmaz. */
exports.ptwKilitSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personAd: zod_1.z.string().min(1),
    benimMi: zod_1.z.boolean(),
    cikarmaAt: zod_1.z.iso.datetime().nullable(),
    zorlaKaldirildi: zod_1.z.boolean(),
});
exports.ptwIzolasyonSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    izolasyonNoktasi: zod_1.z.string().min(1),
    kilitNo: zod_1.z.string().nullable(),
    etiketNo: zod_1.z.string().nullable(),
    durum: zod_1.z.enum(['applied', 'verified', 'removed']),
    takanAd: zod_1.z.string().min(1),
    acikKilitSayisi: zod_1.z.number().int().min(0),
    /** F3·S5 — SAHA YÜZEYİNİN düğmeleri: üçü de @isg/db servis kurallarının
     *  ikizidir (durum + "takan kaldırır" + K5 zinciri); ekran ikinci kural
     *  yazmaz, görünmeyen düğmenin ucu da 409/403 verir. */
    dogrulanabilir: zod_1.z.boolean(),
    kaldirilabilir: zod_1.z.boolean(),
    kilitAsilabilir: zod_1.z.boolean(),
    /** ✏️ K-97: kişisel kilit asma kapısı (`@isg/db ptwKilitAsmaEngeli`). */
    kilitKapisi: kapi_durumu_1.kapiDurumuSchema,
    kilitler: zod_1.z.array(exports.ptwKilitSatiriSchema),
});
/** Açık vardiya devri (K1) — kabul gelmeden güncel sorumlu DEĞİŞMEZ. */
exports.ptwDevirSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    devredenAd: zod_1.z.string().min(1),
    devralanAd: zod_1.z.string().min(1),
    baslatmaAt: zod_1.z.iso.datetime(),
    /** Kabul yalnız DEVRALANDADIR (iki taraflı) — sunucu söyler. */
    kabulEdebilirim: zod_1.z.boolean(),
});
/** K11 tarama izi — eşleşmeyen tarama da görünür (asıl bulgu odur). */
exports.ptwTaramaSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    tarananKod: zod_1.z.string().min(1),
    eslesti: zod_1.z.boolean(),
    ekipmanAd: zod_1.z.string().nullable(),
    tarayanAd: zod_1.z.string().min(1),
    taramaAt: zod_1.z.iso.datetime(),
});
exports.ptwGeriCekilmeSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    gerekceAd: zod_1.z.string().min(1),
    gerekceMetin: zod_1.z.string().nullable(),
    kaynak: exports.ptwGeriCekilmeKaynakSchema,
    durduranAd: zod_1.z.string().min(1),
    zaman: zod_1.z.iso.datetime(),
});
exports.ptwKatilimciSatiriSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    personAd: zod_1.z.string().min(1),
    gorevRefId: zod_1.z.uuid(),
    gorevAd: zod_1.z.string().min(1),
    participantId: zod_1.z.uuid(),
    onayDurumu: zod_1.z.enum(['bekliyor', 'onaylandi']),
    katilimciKararKapisi: kapi_durumu_1.kapiDurumuSchema.nullable(),
});
/**
 * ✏️ K-98 (16.09.2026 — bulgu 98): AKTİF İZNE KATILIMCI EKLEME. Taslak yolu
 * (`PUT …/participants` — tam liste) onaya gitmiş izinde 409 AYNEN; bu dar yol
 * TEK kişi + görev ekler ve kişi izin verenin kararını bekler.
 */
exports.ptwAktifKatilimciEklemeSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    gorevRefId: zod_1.z.uuid(),
});
/** K-98: ret gerekçesi zorunlu (madde 49 deseni) — uç şeması ve motor aynı cümle. */
exports.PTW_KATILIMCI_RET_GEREKCE_METNI = 'Reddetme gerekçesi zorunludur — sorumlu kişinin neden kabul edilmediğini bilmeli';
exports.ptwKatilimciKararSchema = zod_1.z
    .object({
    sonuc: zod_1.z.enum(['onaylandi', 'reddedildi']),
    gerekce: zod_1.z.string().trim().max(2000).nullish(),
})
    .superRefine((deger, ctx) => {
    if (deger.sonuc === 'reddedildi' && !deger.gerekce) {
        ctx.addIssue({ code: 'custom', path: ['gerekce'], message: exports.PTW_KATILIMCI_RET_GEREKCE_METNI });
    }
});
exports.ptwKatilimciKararBekleyenSchema = zod_1.z.object({
    participantId: zod_1.z.uuid(),
    permit: exports.ptwPermitSummarySchema,
    personAd: zod_1.z.string().min(1),
    gorevAd: zod_1.z.string().min(1),
    eklenmeAt: zod_1.z.iso.datetime(),
});
exports.ptwEkipmanSatiriSchema = zod_1.z.object({
    equipmentId: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
    sonrakiKontrol: zod_1.z.iso.datetime().nullable(),
});
/** AÇIK UZATMA TALEBİ (madde 52) — onay yüzü "hangi yeni bitiş, hangi
 *  gerekçe" sorusunu buradan okur; kapı da bu kaydın varlığıdır. */
exports.ptwUzatmaTalebiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    talepEdenAd: zod_1.z.string().min(1),
    yeniBitis: zod_1.z.iso.datetime(),
    gerekce: zod_1.z.string().min(1),
    turNo: zod_1.z.number().int().min(1),
    zaman: zod_1.z.iso.datetime(),
});
exports.ptwPermitDetailSchema = zod_1.z.object({
    permit: exports.ptwPermitSummarySchema,
    acikUzatmaTalebi: exports.ptwUzatmaTalebiSchema.nullable(),
    acikDevir: exports.ptwDevirSatiriSchema.nullable(),
    sonTaramalar: zod_1.z.array(exports.ptwTaramaSatiriSchema),
    izinTurleri: zod_1.z.array(zod_1.z.object({ refId: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    katilimcilar: zod_1.z.array(exports.ptwKatilimciSatiriSchema),
    /** İTA satırları — sıralı (tur 11 / R6). BOŞ OLABİLİR: zorunlu değildir. */
    jsaSatirlari: zod_1.z.array(exports.ptwJsaRowSchema),
    ekipmanlar: zod_1.z.array(exports.ptwEkipmanSatiriSchema),
    guncelSorumluAd: zod_1.z.string().nullable(),
    /** K-95c: taslakta sorumlu seçicisinin güncel değeri. */
    guncelSorumluEmploymentId: zod_1.z.uuid().nullable(),
    gecisler: zod_1.z.array(exports.ptwGecisSatiriSchema),
    onaylar: zod_1.z.array(exports.ptwOnaySatiriSchema),
    /** PTW onay düğmesi (K-62): basamaklar + karar kapısı; zincir yoksa null. */
    onayBasamaklari: exports.ptwOnayBasamaklariSchema.nullable(),
    izolasyonlar: zod_1.z.array(exports.ptwIzolasyonSatiriSchema),
    geriCekilmeler: zod_1.z.array(exports.ptwGeriCekilmeSatiriSchema),
    acikIhlaller: zod_1.z.array(exports.ptwViolationSummarySchema),
    /** Dilim 2 (K-73f) — "Kapalı kontroller" iz satırı (donmuşsa kayıttan). */
    kapaliKontroller: ptw_kontrol_matrisi_1.ptwIzinKapaliKontrolleriSchema,
    yetkiler: exports.ptwPermitYetkileriSchema,
});
exports.ptwPermitOptionsSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    // K2 (tur 10): havuzlar iznin işyerine göre süzülür; kutu açılınca kapanır.
    isyeriyleSinirli: zod_1.z.boolean(),
    lokasyonlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1), seviye: zod_1.z.number().int().min(0) })),
    izinTurleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    gorevler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1), varsayilan: zod_1.z.boolean() })),
    katilimciAdaylari: zod_1.z.array(zod_1.z.object({
        personId: zod_1.z.uuid(),
        ad: zod_1.z.string().min(1),
        // K2.2: null = yüklenici istihdamı yok (rozet çizilmez).
        sahaGirisiGecerli: zod_1.z.boolean().nullable(),
    })),
    sorumluAdaylari: zod_1.z.array(zod_1.z.object({
        employmentId: zod_1.z.uuid(),
        personAd: zod_1.z.string().min(1),
        isverenAd: zod_1.z.string().min(1),
        sahaGirisiGecerli: zod_1.z.boolean().nullable(),
    })),
    /**
     * K-95c (16.09.2026): talep edenin BU işyerindeki aktif istihdamı —
     * sorumlu seçicisinin varsayılanı. KOLAYLIK, KURAL DEĞİL: talep eden sahada
     * olmak zorunda değildir (§16.7.4/2); yoksa `null` ve seçici boş gelir.
     */
    varsayilanSorumluEmploymentId: zod_1.z.uuid().nullable(),
    ekipmanlar: zod_1.z.array(exports.ptwEkipmanSatiriSchema),
    geriCekilmeGerekceleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1), digerMi: zod_1.z.boolean() })),
});
exports.ptwPermitListContractIsInSync = true;
exports.ptwPermitDetailContractIsInSync = true;
exports.ptwPermitOptionsContractIsInSync = true;
exports.ptwPermitFilterOptionsContractIsInSync = true;
// ── F3·S6: tür şablonları + yapılandırma yüzeyi ─────────────────────────────
/** Tür formu — talep formundaki YER TUTUCU bölgenin içeriği. `sema` KAYDIN
 *  sürümünden gelir (kayıt varsa); ekran ikinci şema türetmez (§22.5/3). */
exports.ptwTypeFormSchema = zod_1.z.object({
    izinTuruRefId: zod_1.z.uuid(),
    izinTuruAd: zod_1.z.string().min(1),
    formTemplateId: zod_1.z.uuid(),
    formTemplateAd: zod_1.z.string().min(1),
    templateVersionId: zod_1.z.uuid(),
    surumNo: zod_1.z.number().int().min(1),
    sema: zod_1.z.unknown(),
    submissionId: zod_1.z.uuid().nullable(),
    submissionDurum: zod_1.z.enum(['draft', 'submitted']).nullable(),
});
/** Tür→zorunlu görev matrisinin YAZMA gövdesi (Kapsam §19/14). BOŞ liste
 *  GEÇERLİDİR ve anlamlıdır: "bu türde zorunlu görev yok" müşterinin
 *  verebileceği karardır — sistem taban dayatmaz, bu yüzden min(1) YOK. */
exports.ptwTypeGorevWriteSchema = zod_1.z.object({
    izinTuruRefId: zod_1.z.uuid(),
    gorevRefIds: zod_1.z.array(zod_1.z.uuid()).max(50),
});
/** İşyeri × tür anahtarı (K5) — v1'in tek anahtarı. */
exports.ptwWorkplaceTypeWriteSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    izinTuruRefId: zod_1.z.uuid(),
    kisiselKilitZorunlu: zod_1.z.boolean(),
});
/** Şapka listesi yazımı (S0-K1/K3). `saha_kontrol` BOŞ olamaz kuralı
 *  SERVİSTEDİR (`setPtwAuthorityConfig`) — şema onu tekrarlamaz; iki yerde
 *  duran kural zamanla ayrışır. */
exports.ptwAuthorityWriteSchema = zod_1.z.object({
    kind: zod_1.z.enum(['geri_cekme', 'saha_kontrol']),
    sapkalar: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)).max(shared_types_1.ROLE_TYPES.length),
});
/** QR özet kapsamı yazımı (madde 54) — HOLDİNG DEĞERİ YOKTUR. */
exports.ptwQrKapsamWriteSchema = zod_1.z.object({
    kapsam: zod_1.z.enum(['sirket', 'lokasyon']),
});
exports.ptwConfigOverviewSchema = zod_1.z.object({
    izinTurleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    gorevler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    isyerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    turGorevMatrisi: zod_1.z.array(zod_1.z.object({
        izinTuruRefId: zod_1.z.uuid(),
        izinTuruAd: zod_1.z.string().min(1),
        gorevler: zod_1.z.array(zod_1.z.object({ refId: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    })),
    isyeriTurAyarlari: zod_1.z.array(zod_1.z.object({
        workplaceId: zod_1.z.uuid(),
        workplaceAd: zod_1.z.string().min(1),
        izinTuruRefId: zod_1.z.uuid(),
        izinTuruAd: zod_1.z.string().min(1),
        kisiselKilitZorunlu: zod_1.z.boolean(),
    })),
    geriCekmeSapkalari: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)),
    sahaKontrolSapkalari: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)),
    qrOzetKapsami: zod_1.z.enum(['sirket', 'lokasyon']),
    /** Dilim 2 (K-73b) — kontrol matrisi satırları (holding + tüm işyeri istisnaları). */
    kontrolMatrisiSatirlari: zod_1.z.array(ptw_kontrol_matrisi_1.ptwKontrolMatrisSatiriSchema),
});
exports.ptwTypeFormContractIsInSync = true;
exports.ptwConfigOverviewContractIsInSync = true;
// ── TASLAK KÜNYESİ (28.09.2026 — Kapsam §14 K-T1 · K-T2; §16.7.1) ───────────
/**
 * TASLAKTA KÜNYE YAZ — izin türleri · lokasyon · geçerlilik · iş ekipmanları.
 * Katılımcı · güncel sorumlu · İTA · tür formu kendi uçlarındadır (taslakta
 * zaten düzenlenebiliyorlardı); eksik olan bu dördünün yazma yoluydu.
 *
 * ⚠️ **İŞYERİ GÖVDEDE YOKTUR ve `strict` bunu ZORLAR:** işyeri onay zincirini,
 * ekipman havuzunu ve form kayıtlarını bağlar; yanlış işyeriyle açılan taslağın
 * çıkışı iptaldir. Gövdede gelirse istek reddedilir (sessizce yok saymak,
 * kullanıcıya *"değiştirdim"* sanısı verirdi).
 *
 * ⚠️ **GÖNDERİLEN LİSTELER TAM LİSTEDİR** (`ptwParticipantsSetSchema` deseni).
 * Boş tür / boş ekipman listesi geçerlidir — taslak serbesttir.
 *
 * `elleIcerikOnayi`: çıkarılan türün form kaydında ELLE GİRİLEN içerik varsa
 * sunucu bu bayrak olmadan yazmaz (409 + `ptwKunyeOnayGerekliSchema`).
 */
exports.ptwKunyeSetSchema = zod_1.z
    .object({
    locationId: zod_1.z.uuid(),
    gecerlilikBaslangic: zod_1.z.iso.datetime(),
    gecerlilikBitis: zod_1.z.iso.datetime(),
    izinTuruRefIds: zod_1.z.array(zod_1.z.uuid()).max(50),
    ekipmanIds: zod_1.z.array(zod_1.z.uuid()).max(200),
    elleIcerikOnayi: zod_1.z.boolean().default(false),
})
    .strict();
/**
 * ELLE GİRİLEN İÇERİK SINIFLARI (K-T2 — geniş okuma, ürün sahibi 28.09.2026):
 * *Diğer* metni · serbest metin/sayı/tarih cevabı · madde notu · ek. Listeden
 * yapılan SEÇİM bu sınıflara girmez (yeniden seçmek bir tıktır; yazılan metin
 * geri gelmez).
 */
exports.PTW_ELLE_ICERIK_SINIFLARI = ['diger_metni', 'cevap', 'not', 'ek'];
exports.PTW_ELLE_ICERIK_ETIKETI = {
    diger_metni: 'Diğer açıklaması',
    cevap: 'Yazılan cevap',
    not: 'Not',
    ek: 'Ek',
};
/** Serbest girişli alan tipleri — cevabı ELLE yazılır (seçim/işaret değildir). */
exports.ELLE_GIRILEN_ALAN_TIPLERI = ['metin', 'uzun_metin', 'sayi', 'tarih'];
exports.ptwDusecekIcerikSchema = zod_1.z.object({
    izinTuruRefId: zod_1.z.uuid(),
    izinTuruAd: zod_1.z.string().min(1),
    kalemler: zod_1.z
        .array(zod_1.z.object({
        sinif: zod_1.z.enum(exports.PTW_ELLE_ICERIK_SINIFLARI),
        alanEtiketi: zod_1.z.string().min(1),
        /** İçeriğin kendisi (metin / değer / dosya adı) — kullanıcı neyi kaybedeceğini görür. */
        ozet: zod_1.z.string(),
    }))
        .min(1),
});
/** 409 gövdesi — künye ucu onay bayrağı olmadan tür çıkaramadığında. */
exports.ptwKunyeOnayGerekliSchema = zod_1.z.object({
    message: zod_1.z.string().min(1),
    dusecekIcerik: zod_1.z.array(exports.ptwDusecekIcerikSchema).min(1),
});
exports.PTW_KUNYE_ONAY_GEREKLI_METNI = 'Çıkarılan izin türünün formunda elle girilmiş içerik var — tür çıkarılırsa bu içerik düşer. ' +
    'Onaylayıp yeniden kaydedin.';
// ── İŞ ÖNCESİ BRİFİNG (28.09.2026 — Kapsam §16.7.4 · §14 K-B1…B4) ───────────
/**
 * BRİFİNGİN YAZILABİLDİĞİ DURUMLAR — **POZİTİF LİSTE** (K-B4): açılış onay turu
 * tamamlanmış ve kapanış sürecine girmemiş izin. ⚠️ `expired` BİLİNÇLİ YOK
 * (ürün sahibi 28.09.2026): süresi dolmuş izin uzatma onaylanınca yazılabilir
 * duruma döner. Yeni bir durum token'ı eklenirse kilitli tarafa düşer
 * (`ptwTaslakIcerikKilidi` deseni — negatif koşul sessizce açardı).
 */
exports.PTW_BRIFING_YAZILABILIR_DURUMLAR = [
    'manager_approval',
    'active',
    'suspended',
];
function ptwBrifingYazilabilirMi(durum) {
    return exports.PTW_BRIFING_YAZILABILIR_DURUMLAR.includes(durum);
}
exports.PTW_BRIFING_NOT_MAX_UZUNLUK = 1000;
/**
 * TÜR FORMUNUN ÜÇ STANDART LİSTESİ — brifing konuları buradan okunur (yeni
 * sözlük AÇILMAZ). Kodlar `ptw-form-library-content.ts icerikAlanlari` ile
 * aynıdır; müşterinin kendi eklediği alanlar konu listesine girmez.
 */
exports.PTW_BRIFING_KONU_ALANLARI = [
    'tehlikeler',
    'onlemler',
    'guvenlik_ekipmanlari',
];
exports.ptwBriefingCreateSchema = zod_1.z.object({
    /** Verilmezse sunucu "şimdi" yazar. Gelecek ve onay öncesi → 422 (serviste). */
    verilmeAt: zod_1.z.iso.datetime().optional(),
    notMetni: zod_1.z.string().trim().max(exports.PTW_BRIFING_NOT_MAX_UZUNLUK).nullish(),
    /** `ptw_participant.id` listesi — iznin KAPSAMINDAKİ katılımcılar; en az bir kişi. */
    participantIds: zod_1.z.array(zod_1.z.uuid()).min(1).max(200),
});
exports.ptwBriefingListSchema = zod_1.z.object({
    /** P13 — yazma kapısı + yazamayanın sebebi (uç AYNI adım listesini zorlar). */
    yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * Açılış onay turunun tamamlandığı an — `verilmeAt`in alt sınırı. İzin henüz
     * onaylanmadıysa `null` (o durumda kapı zaten kapalıdır).
     */
    enErkenVerilmeAt: zod_1.z.iso.datetime().nullable(),
    /** Brifing KONULARI — tür formlarında SEÇİLMİŞ kalemler, salt okunur. */
    konular: zod_1.z.array(zod_1.z.object({
        izinTuruAd: zod_1.z.string().min(1),
        tehlikeler: zod_1.z.array(zod_1.z.string()),
        onlemler: zod_1.z.array(zod_1.z.string()),
        guvenlikEkipmanlari: zod_1.z.array(zod_1.z.string()),
    })),
    /** İznin kapsamındaki katılımcılar (hesabı olmayan çalışanlar dahil). */
    katilimciAdaylari: zod_1.z.array(zod_1.z.object({
        participantId: zod_1.z.uuid(),
        personAd: zod_1.z.string().min(1),
        gorevAd: zod_1.z.string().min(1),
    })),
    brifingler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        verenAd: zod_1.z.string().min(1),
        verilmeAt: zod_1.z.iso.datetime(),
        notMetni: zod_1.z.string().nullable(),
        katilimlar: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.uuid(),
            participantId: zod_1.z.uuid(),
            personAd: zod_1.z.string().min(1),
            gorevAd: zod_1.z.string().min(1),
        })),
    })),
});
//# sourceMappingURL=ptw.js.map